// extracted by mini-css-extract-plugin
export var avatarContainer = "_55-0";
export var avatarTypingWave = "_55-i";
export var gray = "_55-f";
export var green = "_55-c";
export var icon = "_55-9";
export var image = "_55-1";
export var lg = "_55-6";
export var md = "_55-5";
export var presenceDot = "_55-b";
export var red = "_55-d";
export var sm = "_55-4";
export var status = "_55-a";
export var typingDot = "_55-h";
export var typingPill = "_55-g";
export var xl = "_55-7";
export var xs = "_55-3";
export var xxl = "_55-8";
export var xxs = "_55-2";
export var yellow = "_55-e";